/** Vertical margin around the whole group (same values as the other controls' componentSpacing). */
export enum SelectionPanelGroupComponentSpacing {
    None = 'noSpacing',
    SmallSpacing = 'smallSpacing',
    StandardSpacing = 'standardSpacing',
    LargeSpacing = 'largeSpacing',
}
